import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import { Icon, type IconName } from './Icon';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  ref?: Ref<HTMLButtonElement>;
  variant?: 'primary' | 'ghost' | 'done';
  small?: boolean;
  trailingIcon?: IconName;
  leadingIcon?: IconName;
  children: ReactNode;
}

export function Button({ variant = 'primary', small, trailingIcon, leadingIcon, className, children, ...rest }: Props) {
  const classes = ['btn', `btn-${variant}`, small ? 'btn-small' : '', className ?? ''].join(' ').trim();
  return (
    <button type="button" className={classes} {...rest}>
      {leadingIcon && <Icon name={leadingIcon} small />}
      {children}
      {trailingIcon && <Icon name={trailingIcon} small />}
    </button>
  );
}

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName;
  label: string;
}

export function IconButton({ icon, label, className, ...rest }: IconButtonProps) {
  return (
    <button type="button" className={['icon-btn', className ?? ''].join(' ').trim()} aria-label={label} title={label} {...rest}>
      <Icon name={icon} />
    </button>
  );
}
